import { render } from "./subheader-table.vue?vue&type=template&id=52d54f8a"
import script from "./subheader-table.vue?vue&type=script&lang=js"
export * from "./subheader-table.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__